import React, { useEffect, useState } from "react";
import { WorkerStatusCard } from '../assets/style'
import { Box, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useTranslation } from "react-i18next";

function LastestAlertCard(props: { data?: any }) {
    const { data } = props;
    const {t, i18n} = useTranslation();
    const [dataArray, setDataArray] = useState(data ? data : []);
    const count = dataArray?.length;

    useEffect(() => {
        // console.log(data);
        if (!(data == null || data == undefined)) {
            setDataArray(data);
        }
    }, [data])

    const generateRows = (count: number) => {
        const rows = [];
        const defaultColor = ["#27ebf2", "#2775f2", "#f2f227", "#27f2b5", "#2a27f2", "#8927f2", "#27f253", "#f28927", "#f227b2", "#f22738"];
        for (let i = 0; i < count && i < count; i++) {
            const [date, timeString] = (dataArray[i]?.alertTime?.split('T')) || [];
            const [time, _] = (timeString?.split('.')) || [];
            rows.push({ id: i, alert: dataArray[i].alertType, projectNo: dataArray[i].projectNumber, loaction: dataArray[i].location, date: date, time: time });
        }
        return rows;
    };

    return (
        <>
            <WorkerStatusCard sx={{ minHeight: '300px', maxHeight: '500px', height: '100%', "@media (max-width: 800px)": { maxWidth: '800px', maxHeight: '500px' } }}>
                <Box sx={{ display: "flex", flexDirection: 'column', alignContent: "center", height: "100%", marginLeft: '20px', marginRight: '20px', "@media (max-width: 800px)": { justifyContent: "center", justifyItems: "center", alignItems: "center", marginLeft: "0px", flexDirection: "column" } }}>
                    <Box sx={{ float: "left", marginTop: "10px", marginLeft: "10px", width: "100%", height: "10%" }}>
                        <Typography variant="h6" style={{ color: "#193057" }}>{t("Lastest Alert")}</Typography>
                    </Box>
                    <Box>
                        <TableContainer sx={{ "@media (max-width: 800px)": { maxWidth: '360px', maxHeight: '450px', height: '90%' }, maxHeight: '360px', overflowY: 'auto' }}>
                            <Table sx={{ maxHeight: "80px" }} size='small' aria-label="simple table">
                                <TableHead sx={{ position: "sticky", top: "0", zIndex: "1", backgroundColor: '#ffffff' }}>
                                    <TableRow>
                                        <TableCell component="th" scope="row" style={{ color: '#1481c9', fontSize: 16 }}>{t("Alert")}</TableCell>
                                        <TableCell align="left" style={{ color: '#1481c9', fontSize: 16 }}>{t("Project No.")}</TableCell>
                                        <TableCell align="left" style={{ color: '#1481c9', fontSize: 16 }}>{t("Location")}</TableCell>
                                        <TableCell align="left" style={{ color: '#1481c9', fontSize: 16 }}>{t("Date")}</TableCell>
                                        <TableCell align="left" style={{ color: '#1481c9', fontSize: 16 }}>{t("Time")}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody sx={{ '& .MuiTableCell-root': { borderBottom: "none" } }}>
                                    {generateRows(count).map((row) => (
                                        <TableRow key={row.id} sx={{ ',&:last-child td, &:last-child th': { borderLeft: 0, borderRight: 0, borderBottom: 4, borderColor: "#ffffff", backgroundColor: "#d7ebfa" } }}>
                                            <TableCell component="th" scope="row">{t(row.alert)}</TableCell>
                                            <TableCell align="left">{row.projectNo}</TableCell>
                                            <TableCell align="left">{row.loaction}</TableCell>
                                            <TableCell align="left">{row.date}</TableCell>
                                            <TableCell align="left">{row.time}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
            </WorkerStatusCard>
        </>
    )
}

export default LastestAlertCard;